/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React from 'react';
import { colors } from '@material-ui/core';
import BusinessIcon from '@material-ui/icons/Business';
import AssistantIcon from '@material-ui/icons/Assistant';
import TranslateIcon from '@material-ui/icons/Translate';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import BeenhereOutlinedIcon from '@material-ui/icons/BeenhereOutlined';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';

import BarChartIcon from '@material-ui/icons/BarChart';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import ViewModule from '@material-ui/icons/ViewModule';
import ChatIcon from '@material-ui/icons/ChatOutlined';
import CodeIcon from '@material-ui/icons/Code';
import DashboardIcon from '@material-ui/icons/DashboardOutlined';
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import FolderIcon from '@material-ui/icons/FolderOutlined';
import HomeIcon from '@material-ui/icons/HomeOutlined';
import AssessmentIcon from '@material-ui/icons/Assessment';
import ListAltIcon from '@material-ui/icons/ListAlt';
import LockOpenIcon from '@material-ui/icons/LockOpenOutlined';
import MailIcon from '@material-ui/icons/MailOutlined';
import PresentToAllIcon from '@material-ui/icons/PresentToAll';
import PeopleIcon from '@material-ui/icons/PeopleOutlined';
import PersonIcon from '@material-ui/icons/PersonOutlined';
import ReceiptIcon from '@material-ui/icons/ReceiptOutlined';
import SettingsIcon from '@material-ui/icons/SettingsOutlined';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import DynamicFeedIcon from '@material-ui/icons/DynamicFeed';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import UpdateIcon from '@material-ui/icons/Update';
import { Label } from '../../components';
import CategoryIcon from '@material-ui/icons/Category';
import StoreIcon from '@material-ui/icons/Store';
import AppleIcon from '@material-ui/icons/Apple';
import FeedbackIcon from '@material-ui/icons/Feedback';
import AssignmentIcon from '@material-ui/icons/Assignment';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import PrintIcon from '@material-ui/icons/Print';
export default [
  {
    title: 'Overview',
    id: 'overview',
    pages: [
      {
        title: 'Analytics',
        href: '/dashboard',
        id: 'anlytics',
        icon: DashboardOutlinedIcon
      },
      {
        title: 'Survey Analytics',
        href: '/survey-analytics',
        id: 'survey_anlytics',
        icon: BeenhereOutlinedIcon
      }
    
    ]
  },
  {
    title: 'App Content',
    id: 'app_content',
    pages: [
      {
        title: 'Futures',
        href: '/updates',
        id: 'update',
        icon: ListAltIcon
      },
      {
        title: 'News',
        href: '/news',
        id: 'news',
        icon: DynamicFeedIcon
      },
      {
        title: 'Spot',
        href: '/spots',
        id: 'spot',
        icon: ViewModuleIcon
      },
      {
        title: 'Live',
        href: '/livelist',
        id: 'live',
        icon: AssessmentIcon
      },
      {
        title: 'Rate',
        href: '/managerates',
        id: 'rate',
        icon: TrendingUpIcon
      }
    ]
  },
  {
    title: 'Advertisement Section',
    id: 'advertisement_section',
    pages: [
      {
        title: 'Ads',
        href: '/manageads',
        id: 'ads',
        icon: AssignmentIcon
      },
     
    ]
  },
  {
    title: 'Survey Section',
    id: 'survey_section',
    pages: [
      {
        title: 'Survey',
        href: '/survey',
        id: 'survey',
        icon: FeedbackIcon
      },
     
    ]
  },
  {
    title: 'User Section',
    id: 'user_section',
    pages: [
      {
        title: 'User Lists',
        href: '/userslist',
        id: 'userlist',
        icon: GroupAddIcon
      },
      {
        title: 'Registered visitors',
        href: '/visitors',
        id: 'visitors',
        icon: HowToRegIcon
      },
      {
        title: 'Stall Bookings',
        href: '/stall-bookings',
        id: 'stall_bookings',
        icon: StoreIcon
      },
      {
        title: 'Print Sticker',
        href: '/print-sticker',
        id: 'print_sticker',
        icon: PrintIcon
      },
      {
        title: 'Subscription Overview',
        href: '/subscription-users',
        id: 'subscription_users',
        icon: ReceiptIcon
      },
      {
        title: 'Feedbacks',
        href: '/feedback',
        id: 'feedback',
        icon: GroupAddIcon
      }
     
    ]
  },
  

  

  


 /* {
    title: 'Buy/Sell',
    pages: [
      {
        title: 'Buy',
        href: '/managebuy/1',
        icon: ImportExportIcon
      },
      {
        title: 'Sell',
        href: '/managebuy/2',
        icon: PresentToAllIcon
      },
      {
        title: 'Master Commodities',
        href: '/mastercommodity',
        icon: CategoryIcon
      },
      {
        title: 'Master Quantity',
        href: '/masterquantity',
        icon: CategoryIcon
      }
    ]
  },*/
  {
    title: 'Master Content',
    id: 'master_content',
    pages: [
      {
        title: 'Live Products',
        href: '/liveproducts',
        id: 'live_products',
        icon: AppleIcon
      },
      {
        title: 'Rate Products',
        href: '/rateproducts',
        id: 'rate_products',
        icon: AppleIcon
      },
      {
        title: 'Brokers',
        href: '/brokers',
        id: 'brokers',
        icon: StoreIcon
      },
      {
        title: 'Commodity',
        href: '/commodity',
        id: 'commodity',
        icon: CategoryIcon
      },
      // {
      //   title: 'Sub Commodity',
      //   href: '/subcommodity',
      //   id: 'subcommodity',
      //   icon: CategoryIcon
      // }
    ]
  },
  {
    title: 'Configuration',
    id: 'configuration',
    pages: [
      // {
      //   title: 'Manage Module',
      //   href: '/masterroutes',
      //   icon: ViewModule
      // },
      // {
      //   title: 'Manage Repository',
      //   href: '/masterrepo',
      //   icon: HomeIcon
      // },
      
      {
        title: 'Manage Languages',
        href: '/masterlanguages',
        id: 'masterlanguages',
        icon: TranslateIcon
      },
      {
        title: 'Membership Plans',
        href: '/subscription-plans',
        id: 'subscription_plans',
        icon: ReceiptIcon
      },
      {
        title: 'Membership Coupons',
        href: '/subscription-coupons',
        id: 'subscription_coupons',
        icon: ReceiptIcon
      },
      {
        title: 'Subscription Settings',
        href: '/subscription-settings',
        id: 'subscription_settings',
        icon: SettingsIcon
      }
    ]
  },
  
  {
    title: 'Employee Management',
    id: 'employee_management',
    pages: [
      {
        title: 'Employees',
        href: '/backofficeusers',
        id: 'employees',
        icon: BusinessIcon
      },
      {
        title: 'Manage Roles',
        href: '/masterroles',
        id: 'manage_roles',
        icon: AssistantIcon
      },
      
      {
        title: 'Manage Role Access',
        href: '/manageroleaccess',
        id: 'manage_role_access',
        icon: AssignmentTurnedInIcon
      }
    ]
  },
  
  {
    title: 'Settings',
    id : 'settings',
    pages: [
      {
        title: 'Profile',
        href: '/settings',
        id: 'profile',
        icon: BarChartIcon
      },
      {
        title: '',
        href: '/events',
        icon: null
      }
    ]
  }
];
